import { render } from "./SectionTextWithImg.vue?vue&type=template&id=60e2a05c"
import script from "./SectionTextWithImg.vue?vue&type=script&lang=js"
export * from "./SectionTextWithImg.vue?vue&type=script&lang=js"

import exportComponent from "/Users/akrug/Sites/RetirePath/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__